// 下載模板
export const downloadSeatDemo = async () => {
    const src = encodeURIComponent('https://cdn.sounova.com/assets/event/year/demo.png');

    const res = await fetch(`/api/download-image?src=${src}`);
    const blob = await res.blob();

    // 建立 blob URL
    const blobUrl = URL.createObjectURL(blob);

    // 強制下載
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = '年菜圍爐座位表範例.png';
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(blobUrl);
};
